import { render } from "./component-adress-locality-name.vue?vue&type=template&id=4a7ade72"
import script from "./component-adress-locality-name.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-locality-name.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-locality-name.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a7ade72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a7ade72', __exports__)) {
    api.reload('4a7ade72', __exports__)
  }
  
  module.hot.accept("./component-adress-locality-name.vue?vue&type=template&id=4a7ade72", () => {
    api.rerender('4a7ade72', render)
  })

}


export default __exports__